var render, staticRenderFns
import script from "./UIButton.vue?vue&type=script&lang=js&"
export * from "./UIButton.vue?vue&type=script&lang=js&"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=847d5d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847d5d1e",
  null
  
)

export default component.exports